/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const ExportOutlinedIcon = ({
  className,
  style,
  color = '#597EF7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.7981 7.96292H11.9505C11.775 7.96292 11.6327 8.10522 11.6327 8.28075V12.1449C11.6327 12.35 11.4658 12.5169 11.2607 12.5169H3.85504C3.64998 12.5169 3.48319 12.35 3.48319 12.1449V4.73943C3.48319 4.53428 3.64998 4.36736 3.85504 4.36736H7.91707C8.09259 4.36736 8.2349 4.22506 8.2349 4.04954V3.20201C8.2349 3.02649 8.09259 2.88419 7.91707 2.88419H3.85504C2.83215 2.88419 2 3.71646 2 4.73943V12.1449C2 13.1679 2.8322 14.0001 3.85504 14.0001H11.2606C12.2836 14.0001 13.1159 13.1679 13.1159 12.1449V8.28079C13.1159 8.10522 12.9736 7.96292 12.7981 7.96292Z"
        fill="#597EF7"
      />
      <path
        d="M13.6823 2H10.3111C10.1355 2 9.99323 2.1423 9.99323 2.31782V3.16535C9.99323 3.34088 10.1355 3.48318 10.3111 3.48318H11.4681L7.11411 7.83706C6.98999 7.96118 6.98999 8.16239 7.11411 8.28655L7.71341 8.88588C7.77303 8.94551 7.85384 8.97898 7.93817 8.97898C8.02246 8.97898 8.10332 8.94551 8.1629 8.88588L12.5169 4.53191V5.68892C12.5169 5.86444 12.6592 6.00674 12.8347 6.00674H13.6823C13.8578 6.00674 14.0001 5.86444 14.0001 5.68892V2.31782C14.0001 2.1423 13.8578 2 13.6823 2Z"
        fill={color}
      />
    </svg>
  );
};
